"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const ChevronLeft_1 = tslib_1.__importDefault(require("@mui/icons-material/ChevronLeft"));
const ChevronRight_1 = tslib_1.__importDefault(require("@mui/icons-material/ChevronRight"));
const Info_1 = tslib_1.__importDefault(require("@mui/icons-material/Info"));
const Tabs_1 = tslib_1.__importDefault(require("@mui/material/Tabs"));
const Sidebar_1 = tslib_1.__importDefault(require("./Sidebar"));
const SidebarIconButton_1 = tslib_1.__importDefault(require("./SidebarIconButton"));
const SidebarTab_1 = tslib_1.__importDefault(require("./SidebarTab"));
const SidebarTabPanel_1 = tslib_1.__importDefault(require("./SidebarTabPanel"));
const SidebarRight = (props) => {
    const { open, size, classes, tabs, selectedValue, onSelectedValueChange, onOpen, onClose, maxWidth, minWidth = 296, ...restProps } = props;
    /**
     * Determines the appropriate flex basis for a component based on its open state and size.
     * @param {boolean} open - Whether the sidebar/menu is open.
     * @param {string} size - The size category of the sidebar ('sm', 'md', or other).
     * @param {object} theme - The theme object that includes spacing definitions.
     * @returns {string} The CSS value for flex basis.
     */
    function determineFlexBasis(theme) {
        if (!open) {
            return theme.spacing(7);
        }
        switch (size) {
            case "sm":
                return "17vw";
            case "md":
                return "26vw";
            case "lg":
                return "43vw";
            default:
                return "43vw";
        }
    }
    const sidebarProps = {
        ...restProps,
        "aria-label": "Right sidebar",
        open,
        sx: (theme) => ({
            flexDirection: "row",
            minWidth: open ? minWidth : theme.spacing(7),
            maxWidth: open && maxWidth ? maxWidth : "unset",
            flex: `0 0 ${determineFlexBasis(theme)}`,
        }),
    };
    const tabElements = tabs.map(({ value, icon, tooltipTitle, TooltipProps, SidebarTabProps }) => (react_1.default.createElement(SidebarTab_1.default, { key: `sidebarTab-${value}`, icon: icon || react_1.default.createElement(Info_1.default, { fontSize: "medium" }), tooltipTitle: tooltipTitle, TooltipProps: TooltipProps, value: value, ...SidebarTabProps, onClick: onOpen })));
    const tabContentElements = tabs.map(({ value, content, disableGutters, primaryHeader, secondaryHeader }) => (react_1.default.createElement(SidebarTabPanel_1.default, { content: content, disableGutters: disableGutters, key: `sidebarPanel-${value}`, primaryHeader: primaryHeader, secondaryHeader: secondaryHeader, selectedValue: selectedValue, value: value })));
    return (react_1.default.createElement(Sidebar_1.default, { ...sidebarProps },
        react_1.default.createElement(Tabs_1.default, { orientation: "vertical", value: selectedValue, onChange: onSelectedValueChange, sx: (theme) => ({
                borderRight: `1px solid ${theme.palette.divider}`,
                minWidth: "57px",
                width: "57px",
                ".MuiTabs-flexContainer": {
                    flexDirection: "column",
                },
                ".MuiTabs-flexContainerVertical": {
                    "& > a:first-of-type": {
                        mb: 3,
                    },
                },
                ".MuiTabs-indicator": {
                    backgroundColor: theme.palette.secondary.main,
                },
            }) },
            open && (react_1.default.createElement(SidebarIconButton_1.default, { "aria-label": "Close right sidebar", onClick: onClose },
                react_1.default.createElement(ChevronRight_1.default, null))),
            !open && (react_1.default.createElement(SidebarIconButton_1.default, { "aria-label": "Open right sidebar", onClick: onOpen },
                react_1.default.createElement(ChevronLeft_1.default, null))),
            tabElements),
        tabContentElements));
};
exports.default = SidebarRight;
